module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enabled && (_vm.alerts.length || _vm.dismissedCount)) ? _c('div', {
    staticClass: "dropdown notificationicoblock system-alert-block"
  }, [_c('span', {
    staticClass: "notificationico pointer header_icon system-alert-ico",
    class: _vm.severityClass,
    attrs: {
      "title": _vm.iconTitle,
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-label": "system alerts"
    }
  }, [_c('i', {
    staticClass: "far fa-bell"
  }), _vm._v(" "), (_vm.totalCount > 0) ? _c('span', {
    staticClass: "notification_count"
  }, [_vm._v(_vm._s(_vm.totalCount))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right mt10 system-alert-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', {
    staticClass: "viewallNotify system-alert-menu-head"
  }, [(_vm.alerts.length) ? _c('a', {
    staticClass: "system-alert-dismiss-all",
    class: {
      'is-busy': _vm.dismissingAll
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.dismissAll($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.dismissingAll ? 'Dismissing…' : 'Dismiss all'))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "system-alert-viewall",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToAlerts($event)
      }
    }
  }, [_vm._v("View all")])]), _vm._v(" "), (!_vm.alerts.length) ? _c('li', {
    staticClass: "system-alert-empty"
  }, [_c('div', {
    staticClass: "notificationClick"
  }, [_c('h6', {
    staticClass: "fs-14 bold m-0 lh_18"
  }, [_vm._v("Nothing needs attention right now")]), _vm._v(" "), _c('small', {
    staticClass: "opacity-75 block"
  }, [_vm._v("\n          " + _vm._s(_vm.dismissedCount) + " dismissed issue(s) are still unfixed and will\n          come back tomorrow.\n        ")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.alerts), function(alert) {
    return _c('li', {
      key: alert.id
    }, [_c('div', {
      staticClass: "notificationClick system-alert-row"
    }, [_c('span', {
      staticClass: "system-alert-dot",
      class: 'sev-' + alert.severity
    }), _vm._v(" "), _c('div', {
      staticClass: "system-alert-body"
    }, [_c('h6', {
      staticClass: "fs-14 bold m-0 lh_18"
    }, [_vm._v(_vm._s(alert.title))]), _vm._v(" "), (alert.impact) ? _c('small', {
      staticClass: "opacity-75 block"
    }, [_vm._v(_vm._s(alert.impact))]) : _vm._e(), _vm._v(" "), _c('small', {
      staticClass: "opacity-50 block"
    }, [_vm._v(_vm._s(alert.detected_at))]), _vm._v(" "), _c('div', {
      staticClass: "system-alert-actions"
    }, [(alert.action_route) ? _c('a', {
      staticClass: "a_color",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToFix(alert)
        }
      }
    }, [_vm._v(_vm._s(alert.action_text || 'Open settings'))]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "a_color ml10",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.dismiss(alert)
        }
      }
    }, [_vm._v("Dismiss")])])])])])
  })], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49619a10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/system_alert_bell.vue
// module id = 1536
// module chunks = 32